export enum CashRegisterDeviceChallengePurpose {
  UI_VERIFICATION = 'ui_verification',

  OPEN_REGISTER_SESSION = 'open_register_session',
  CLOSE_REGISTER_SESSION = 'close_register_session',

  SUBMIT_TRANSACTION = 'submit_transaction',
  PARK_TRANSACTION = 'park_transaction',
  REVERSE_TRANSACTION = 'reverse_transaction',

  CREATE_CASH_MOVEMENT = 'create_cash_movement',
  UPDATE_CASH_MOVEMENT = 'update_cash_movement',
  DELETE_CASH_MOVEMENT = 'delete_cash_movement',

  VIEW_X_REPORT = 'view_x_report',
}